import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const TIRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnAnstalld,
  rutinInfos.rtnRapporteringsobjekt,
  rutinInfos.rtnTIProjekt,
  rutinInfos.rtnArbetsuppgifter,
  rutinInfos.rtnAnstalldBegr,
  rutinInfos.rtnTidrapporteringBegr,
  rutinInfos.rtnPeriodregistreringBegr,
  rutinInfos.rtnFordelaTidBegr,
  rutinInfos.rtnRegistreraForDemo,
  rutinInfos.rtnTidregistrering,
  rutinInfos.rtnPeriodregistrering,
  rutinInfos.rtnFordelaTid,
  rutinInfos.rtnTidrapporteringar,
  rutinInfos.rtnDagrapporteringar,
  rutinInfos.rtnManadsAvslut,
  rutinInfos.rtnLoneunderlag,
  rutinInfos.rtnSpecTIRapport,
  rutinInfos.rtnPafyllSemDagar,
  rutinInfos.rtnOBRegistrering,
];

export default TIRutinMeny;
